import extend from '@/utils/vuex-extend';
import {table} from '@/vuex-extend';
import {fetchList} from '@/api/oms/problem-order';
import {getCancelReasonList} from '@/api/oms/order';

import {wait} from '@/utils/wait';

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {},
		reasonList: []
	},
	actions: {
		async getList({state, dispatch}, payload) {
			await wait(dispatch, 'oms.order.list', async function () {
				let {searchForm} = state;
				const params = {}
				params[searchForm.select] = searchForm.value
				if (searchForm.timeValue && searchForm.timeValue) {
					params.orderTime = {
						start: parseInt(searchForm.timeValue[0] / 1000),
						end: parseInt(searchForm.timeValue[1] / 1000)
					}
				}
				await dispatch('getData', {
					caller: fetchList,
					options: {
						...params,
						...payload
					}
				});
			})
		},
		async getReasonList({state, dispatch, commit}, payload) {
			await wait(dispatch, 'oms.order.list', async function () {
				await wait(dispatch, 'sms.order.reason-list', async function () {
					const response = await getCancelReasonList();
					if (response.data) {
						commit('save', {
							reasonList: response.data
						})
					}
				})
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/oms/problem-order/list.js